
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user/register/add-location",
      function () {
        return require("private-next-pages/user/register/add-location.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/user/register/add-location"])
      });
    }
  